import React from 'react';
import AppIcons from '../../assets/images/icons';
import { Button, TextField } from '@mui/material';
import { Link } from "react-router-dom";
import { NavHashLink } from 'react-router-hash-link';

import { showSnackbar } from '../Notification/Snackbar';
import { postQuery } from '../../services/api/enquires';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
import './footer.scss';
import SVGIcons from '../../assets/images/icons/svgIcons';
import TrustedPartnersPopup from '../trustedPartnersPopup/trustedPartnersPopup';
import ContactPopup from '../ContactPopup/ContactPopup';


const Footer = () => {


    const [formData, setFormData] = React.useState({});
    /**
     * sets the form data 
     * @param {string} name the name of the field
     * @param {string} value  the value of the field
     */
    const setFormValue = (name, value) => {
        const formDataAs = { ...formData };
        setFormData({ ...formDataAs, ...{ [name]: value } });
    }

    /**
     * Validates the form and returns true if valid
     * @returns boolean
     */
    const isValidForm = () => {
        let isValid = false;
        if (formData.email) {
            isValid = true;
        }
        return isValid;
    }

    /**
     * On submit the form
     */
    const onSubmit = () => {
        if (isValidForm()) {
            const formPostData = {
                email: formData.email,
            }

            postQuery(formPostData).then((data) => {
                if (data.success) {
                    setFormData(null);
                    showSnackbar().success(data.message)
                } else {
                    showSnackbar().failure(data.message)

                }
            });
        }
    };


    return (

        <>
            {/* {currentURL === '/' || currentURL === '/about-us'  ? */}

            <div className='footer-revamp-wrp f-wrp'>
                <div className='main-footer f-wrp'>
                    <div className='container'>
                        <div className='foot-link-wrp f-wrp'>
                            <div className="row">
                                <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                                    <div className="foot-logo-box f-wrp">
                                        <div className="logo-wrp f-wrp">
                                            <span><img src={AppIcons.footerLogo} alt="logo" /></span>
                                            <p>Building 3b, Street 69a <br />Jumeirah 1, Dubai <br />United Arab Emirates</p>
                                            <br />
                                            <p className='contact'><a href="tel:+971568816886"><SVGIcons.PhoneIcon2 /> +971-56-881-6886</a></p>
                                            <br />
                                            <p className='contact'><a href="mailto:admin@propshop.ai"><SVGIcons.MailIcon2 /> admin@propshop.ai</a></p>



                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-4 col-sm-12 col-xs-12">
                                    <div className="each-foot-link f-wrp">
                                        <h4 className="foot-sub-head">Services</h4>
                                        <ul>
                                            <li><Link to={'/off-plan'}>Off Plan</Link></li>
                                            <li><Link to={'/exclusive-listings?mode=buy'}>Secondary</Link></li>
                                            <li><Link to={'/services'}>Property Management</Link></li>
                                            <li><Link to={'/blog'}>Insights</Link></li>

                                            <li><NavHashLink smooth to={'/#become-an-agent'}>Become an Agent</NavHashLink></li>
                                        </ul>

                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12">
                                    <div className="each-foot-link f-wrp">
                                        <h4 className="foot-sub-head">Company</h4>
                                        <ul>
                                            <li><Link to={'/about-us'}>About</Link></li>
                                            <li><TrustedPartnersPopup /></li>
                                            {/* <li><Link to={'/'}>Developers</Link></li> */}
                                            <li><NavHashLink smooth to={'/about-us/#our-team'}>Team</NavHashLink></li>
                                            <li><ContactPopup /></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                    <div className="each-foot-link f-wrp">
                                        <h4 className="foot-sub-head">Stay in the Know
                                            <p className='subscribe-info-text' >Get exclusive real estate insights — no spam ever.</p>
                                        </h4>


                                        <div className='email-subscription-box f-wrp'>
                                            <TextField
                                                id="email-subscription"
                                                name="email-subscription"
                                                placeholder="Email Address"
                                                type="email"
                                                fullWidth
                                                onChange={(e) => setFormValue('email', e.target.value)}
                                            />
                                            <Button className='subscription-btn' disabled={!isValidForm()} onClick={onSubmit}><SVGIcons.RoundArrowIcon /></Button>
                                        </div>

                                        <h4 className="foot-sub-head f-wrp" style={{ paddingTop: '20px' }}>Follow Us on</h4>

                                        <div className='social-list f-wrp'>
                                            <ul style={{ justifyContent: 'flex-start' }}>
                                                <li><span onClick={() => window.open('/', '_blank')}><SVGIcons.TwitterIcon /></span></li>
                                                <li><span onClick={() => window.open('/', '_blank')}><SVGIcons.YoutubeIcon /></span></li>
                                                <li><span onClick={() => window.open('https://www.linkedin.com/company/propshop-real-estate/')}><SVGIcons.LinkedInIcon /></span></li>
                                                <li><span onClick={() => window.open('https://www.facebook.com/profile.php?id=100090850307997')}><SVGIcons.FaceBookIcon /></span></li>
                                                <li><span onClick={() => window.open('https://www.instagram.com/propshop.ai/', '_blank')}><SVGIcons.InstagramIcon /></span></li>
                                            </ul>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <button type="button" id="waPropshop" onClick={() => {
                                window.open('https://wa.me/971568816886', '_blank')
                            }} className='whatsapp-btn'><SVGIcons.WhatsappIcon /></button>


                        </div>
                    </div>
                </div>

                <div className='copy-foot f-wrp'>
                    <div className='container'>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className="copy-txt f-wrp">
                                    <p>© Propshop – All rights reserved 2024 </p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <div className='link-list f-wrp'>
                                    <ul>
                                        <li><Link to={'/terms-and-conditions'}>Terms and Conditions</Link></li>
                                        <li><Link to={'/privacy-policy'}>Privacy Policy</Link></li>
                                        <li><Link to={'/disclaimer'}>Disclaimer</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <>  :
                <div className="project-main-footer f-wrp">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                <div className="foot-logo-wrp f-wrp">
                                    <div className="logo-wrp f-wrp">
                                        <span><img src={AppIcons.footLogo} alt="Propshop Logo" /></span>
                                        <span className='foottag'><img src={AppIcons.foottag} alt="Propshop tag-line" /></span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                        <div className="each-foot-link align-class1 f-wrp">
                                            <label className="foot-sub-head">Platform</label>
                                            <MenuList>
                                                <MenuItem><Link to={'/exclusive-listings'}>Listings</Link></MenuItem>
                                                

                                                <NavHashLink smooth to={`/traditional/#testimonials`} >
                                                    <MenuItem><span>Testimonials</span></MenuItem>
                                                </NavHashLink>


                                            </MenuList>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                                        <div className="each-foot-link align-class2 f-wrp">
                                            <label className="foot-sub-head">Services</label>
                                            <MenuList>
                                                <MenuItem><a href={`${url}/fractional`}>Fractional ownership</a></MenuItem>
                                                <NavHashLink smooth to={`/traditional/#Services`} >
                                                    <MenuItem><span>Interior design</span></MenuItem>
                                                </NavHashLink>
                                                <NavHashLink smooth to={`/traditional/#Services`} >
                                                    <MenuItem><span>Architectural design</span></MenuItem>
                                                </NavHashLink>
                                                <NavHashLink smooth to={`/traditional/#Services`} >
                                                    <MenuItem><span>Landscaping</span></MenuItem>
                                                </NavHashLink>
                                                <NavHashLink smooth to={`/traditional/#Services`} >
                                                    <MenuItem><span>Fengshui</span></MenuItem>
                                                </NavHashLink>
                                                <NavHashLink smooth to={`/traditional/#OtherServices`} >
                                                    <MenuItem><span>Other services</span></MenuItem>
                                                </NavHashLink>
                                            </MenuList>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                                        <div className="each-foot-link align-class3 f-wrp">
                                            <label className="foot-sub-head">Collaborators</label>
                                            <MenuList>
                                                <NavHashLink smooth to={`/traditional/#TrustedPartners`} >
                                                    <MenuItem><span>Trusted partners</span></MenuItem>
                                                </NavHashLink>
                                                <NavHashLink smooth to={`/traditional/#TrustedPartners`} >
                                                    <MenuItem><TrustedPartnersPopup /></MenuItem>
                                                </NavHashLink>
                                                <NavHashLink smooth to={`/traditional/#TopDevelopers`} >
                                                    <MenuItem><span>Top developers</span></MenuItem>
                                                </NavHashLink>
                                            </MenuList>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                        <div className="each-foot-link align-class4 f-wrp">
                                            <label className="foot-sub-head">Company</label>
                                            <MenuList>
                                                <MenuItem onClick={() => window.open('https://wa.me/971568816886', '_blank')}>Contact Us</MenuItem>
                                                <MenuItem><Link to={'/about-us'} >About Us</Link></MenuItem>
                                            </MenuList>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 foot-cpy-sec">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                                        <div className="copy-txt f-wrp">
                                            <p>© 2023 Propshop Real Estate </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="copy-txt f-wrp">
                                            <p>Al Fattan Plaza Office 508/509, Al Garhoud Airport Road, Dubai, United Arab Emirates</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 each-foot-link">
                                        <div className='social-list f-wrp'>
                                            <ul>
                                                <li><span onClick={() => window.open('https://www.instagram.com/propshop.ai', '_blank')}><img src={AppIcons.insta} alt="instagram" /></span></li>
                                                <li><span onClick={() => window.open('https://www.facebook.com/profile.php?id=100090850307997', '_blank')}><img src={AppIcons.facebook} alt="facebook" /></span></li>
                                                <li><span onClick={() => window.open('https://www.linkedin.com/company/propshop-real-estate/')}><img src={AppIcons.linkedin} alt="linkedin" /></span></li>
                                                <li><span onClick={() => window.open('https://www.tiktok.com/@sarsoorah')}><img src={AppIcons.ticktok} alt="ticktok" /></span></li>
                                                <li><span onClick={() => window.open('https://wa.me/971568816886', '_blank')}><img src={whatsappBlk} alt="whatsapp" /></span></li>
                                                
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }</> */}
        </>



    )
}

export default Footer;